import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { useServer } from '@/modules/server/context/ServerEnvContext';
import { useCommonStore } from '@/store';

export const useGamesFiltration = () => {
  const {
    isAuthenticated,
    user,
    recentGamesIds,
    fetchRecentGames,
    fetchProviders,
  } = useCommonStore(
    useShallow((state) => ({
      isAuthenticated: state.isAuthenticated,
      user: state.user,
      recentGamesIds: state.recentGamesIds,
      fetchRecentGames: state.fetchRecentGames,
      fetchProviders: state.fetchProviders,
    }))
  );

  const { isMobileDevice } = useServer();

  useEffect(() => {
    fetchProviders();
  }, [fetchProviders, user]);

  useEffect(() => {
    if (!isAuthenticated || !recentGamesIds.length) return;

    fetchRecentGames(isMobileDevice);
  }, [isAuthenticated, recentGamesIds, isMobileDevice, fetchRecentGames]);
};
